/*
 * Copyright (c) 2025 Ipivot Corporation.
 * All rights reserved.
 * This software is the confidential and proprietary information of
 *  Ipivot Corporation ("Confidential Information").
 */
import { createContext } from 'react';

export class WsContextType {
    ws: any;
};

export const WsContext = createContext<WsContextType>(new WsContextType());